export const URLS = {
  home: `/`,
  tasks: `/tasks/`,
  status: "/status",
  folder: (folderId: string | number) => `/folder/${folderId}`,
  library: "/library",
} as const;
